export default __webpack_public_path__ + "static/Image 36-1af4ddaa583de2549ace881f59e11708.png";